import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { Pressable, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FlashAnimation } from '../FlashAnimation';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
import { flashStyle, flashStyleOld } from './styles';
import { fg } from '@atlaskit/platform-feature-flags';
var reactionStyles = xcss({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  minWidth: '36px',
  height: '24px',
  backgroundColor: 'color.background.neutral.subtle',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  borderRadius: 'border.radius.circle',
  color: 'color.text.subtle',
  marginBlockStart: 'space.050',
  marginInlineEnd: 'space.050',
  padding: 'space.0',
  overflow: 'hidden',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  }
});
var reactionStylesRefresh = xcss({
  borderRadius: 'border.radius'
});
export var ReactionButton = function ReactionButton(_ref) {
  var onClick = _ref.onClick,
    _ref$flash = _ref.flash,
    flash = _ref$flash === void 0 ? false : _ref$flash,
    _ref$additionalStyles = _ref.additionalStyles,
    additionalStyles = _ref$additionalStyles === void 0 ? [] : _ref$additionalStyles,
    ariaLabel = _ref.ariaLabel,
    ariaPressed = _ref.ariaPressed,
    onMouseEnter = _ref.onMouseEnter,
    onFocus = _ref.onFocus,
    children = _ref.children,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    testId = _ref.testId;
  return jsx(Pressable, _extends({
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onFocus: onFocus,
    "aria-label": ariaLabel,
    "aria-pressed": ariaPressed,
    testId: testId,
    xcss: [reactionStyles].concat(_toConsumableArray(additionalStyles), [
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    fg('platform-component-visual-refresh') && reactionStylesRefresh])
  }, dataAttributes), jsx(FlashAnimation, {
    flash: flash
    /* eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */,
    css: fg('platform-component-visual-refresh') ? flashStyle : flashStyleOld
  }, children));
};